import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { OnDisplayService } from '../ondisplay/onDisplay.service';

@Injectable({
	providedIn: 'root',
})
export class DbresetService {
	constructor(private http: HttpClient) {}

	getLeads() {
		const url = `${environment.api}dbreset/get_leads`;
		return this.http.get(url);
	}

	searchDBReset(filters: any): Observable<any> {
		const formData = new FormData();
		Object.keys(filters).forEach((key) => {
			formData.append(`filters[${key}]`, filters[key] || '');
		});

		const url = `${environment.api}dbreset/search_dbreset`;
		return this.http.post(url, formData);
	}

	getDisposByPhone(primary_phone: string) {
		const formData = new FormData();
		formData.append('primary_phone', primary_phone);
		const url = `${environment.api}dbreset/get_dispo_by_phone_number`;
		return this.http.post(url, formData);
	}

	countSearchs() {
		const url = `${environment.api}dbreset/zip_searchs_by_hour`;
		return this.http.get(url);
	}
}
